import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const MySlyder = ({ data, settings }) => {

  return (
    <Slider {...settings}>
      {data.length &&
        data.map((banner, index) => {
          return (
            <div key={index} className="item container_item">
              <div className="shadow-bg"></div>
              <img alt="" src={`${banner?.bannerimage}`} key={index} width="100%" style={{ maxHeight: "90vh" }} />
            </div>
          );
        })}
    </Slider>
  );
};

export default MySlyder;
